<template>
  <div>
    <div class="md-layout">
      <label for="name">
        <b class="md-layout-item md-caption">{{ tx(model) }}</b></label
      >
      <helpWidget
        v-if="this.attributes.help_img || help_key"
        class="md-layout-item pl-3"
        :help="help_key"
        :help_img="
          this.attributes.help_img
            ? `${this.IREALCONFIG.static_ressources}/${this.attributes.help_img}.png`
            : ''
        "
        :help_style="this.attributes.help_style"
      ></helpWidget>
    </div>
    <div v-show="array.length==0" class="text-sm text-danger"> {{ $t('required_one_least') }} </div> 
    <div class="row">

      <div v-for="o in options" :key="o">
        <md-checkbox
          class="col-sm"
          :click="limit_check()"
          v-model="array"
          :value="o"
          >{{ tx(`${model}_${o}`) }}</md-checkbox
        >

      </div>
    </div>
    
    </div>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import Bus from "../services/bus.js";

export default {
  mixins: [inputComponentMixin, componentMixin, dataComponentMixin],
  name: "RegularCheckboxes",
  data: () => ({
    array: [],
  }),
  async mounted() {
    if (this.attributes.options === undefined) this.quantity = {};
    else {
      var tab = this.attributes.options.split("|");
    }
    this.update_selected();

    Bus.$on("selected-changed", () => {
      this.update_selected();
    });
  },
  watch: {
    array: function (list) {
      if (this.attributes.limit_check) {
        if (this.array.length > this.attributes.limit_check) {
          this.array.pop();
        }
      }
    },
  },
  computed: {
    options() {
      if (this.attributes.options === undefined) return [];
      else return this.attributes.options.split("|");
    },
  },
  methods: {
    limit_check() {
      this.value = this.array;
    },
  },
};
</script>

<style lang="scss" scoped>
.md-checkbox {
  display: flex;
}

table {
  width: 100%;
  table-layout: fixed;

  th {
    text-align: left;
  }
}
</style>
